import axios from "axios";
import { storeService } from "../services";
import buttonLoader from "../utilities/buttonLoader.js";
import Menu from "../components/megamenu";
import getTemplate from "../utilities/getTemplate";
import disableScroll from "disable-scroll";

const quantity = require("../components/quantity");

class Cart {
	constructor() {
		this.props = {
			addToCartForms: document.querySelectorAll(".add-to-cart-form"),
			cartPreview: document.querySelector(".cartpreview"),
			previewProducts: document.querySelectorAll(".js-cart-item"),
			toggleCart: document.querySelector(".cartbtn-js"),
			totalQuantity: document.querySelector(".total-quantity-js"),
			totalPrice: document.querySelector(".js-cart-total"),
			cartPaybtn: document.querySelector(".cartpreview-checkout"),
			items: [],
		};
		this.bindAddToCart();
		this.bindTogglePreview();
		this.bindCloseCartPreview();
		this.bindActions();
		this.bindCouponForm();
		this.addOrderLine = this.addOrderLine.bind(this);
		this.bindUpdateQuantity = this.bindUpdateQuantity.bind(this);
	}

	bindActions() {
		const { previewProducts, cartPaybtn } = this.props;
		if (previewProducts) {
			Array.prototype.forEach.call(previewProducts, (product) => {
				this.bindRemoveSinglePreview(product);
				this.bindUpdateQuantity(product);
			});
		}
		if (cartPaybtn) {
			cartPaybtn.addEventListener("click", (e) => {
				buttonLoader.start(e.target);
			});
		}
		const cartpreviewCloseBtn = document.querySelector(".cartpreview-close");
	}

	bindAddToCart() {
		const { addToCartForms } = this.props;

		Array.prototype.forEach.call(addToCartForms, (addToCartForm) => {
			addToCartForm.addEventListener("submit", this.addOrderLine, false);
		});
	}

	bindTogglePreview() {
		const { toggleCart, cartPreview } = this.props;
		if (toggleCart) {
			document.querySelector(".header").addEventListener("click", (e) => {
				if (cartPreview.classList.contains("cartpreview--show")) {
					document.body.classList.remove("disable-scroll");
					cartPreview.classList.remove("cartpreview--show");
				}
			});
			const wrapper = document.querySelector(".wrapper");
			const footer = document.querySelector("footer");

			toggleCart.addEventListener("click", (e) => {
				const menu = document.querySelector(".megamenu");
				if (menu.classList.contains("megamenu--active")) {
					Menu.closeMenu();
					disableScroll.off();
				}
				if (cartPreview.classList.contains("cartpreview--show")) {
					document.body.classList.remove("disable-scroll");
					cartPreview.classList.remove("cartpreview--show");
					disableScroll.off();
					document
						.querySelector(".js-hamburger")
						.classList.remove("hamburger-is-active");
				} else if (!cartPreview.querySelector(".cartpreview__orderlines")) {
					this.renderPreviewCart();
				} else {
					document.body.classList.add("disable-scroll");
					cartPreview.classList.add("cartpreview--show");
					document
						.querySelector(".js-hamburger")
						.classList.add("hamburger-is-active");
					disableScroll.on(wrapper);
					disableScroll.on(footer);
				}
			});
		}
	}

	bindCloseCartPreview() {
		const { cartPreview } = this.props;
		if (cartPreview) {
			document.body.addEventListener("click", (e) => {
				if (cartPreview.classList.contains("cartpreview--show")) {
					const cartPreviewMatches = e.target.matches
						? e.target.matches(".cartpreview")
						: e.target.msMatchesSelector(".cartpreview");
					const cartNoClickMatches = e.target.matches
						? e.target.matches(".cart-no-click")
						: e.target.msMatchesSelector(".cart-no-click");
					const cartBtnMatches = e.target.matches
						? e.target.matches(".cartbtn-js")
						: e.target.msMatchesSelector(".cartbtn-js");

					if (cartPreviewMatches && !cartNoClickMatches && !cartBtnMatches) {
						const hamburger = document.querySelector(".js-hamburger");
						hamburger.classList.remove("hamburger-is-active");
						this.closeCartPreview();
						disableScroll.off();
					}
				}
			});
		}
	}

	bindUpdateQuantity(product) {
		const quantitySubmit = product.querySelectorAll(".quantity__button");
		const quantityContainer = product.querySelector(
			".js-cartpreview__quantity",
		);
		const quantityLoader = product.querySelector(".js-quantity-loader");
		quantity.bindContainer(quantityContainer);

		if (quantitySubmit) {
			Array.prototype.forEach.call(quantitySubmit, (submit) => {
				submit.addEventListener("click", (e) => {
					const quantityInput = product.querySelector(".cartpreview__qInput");
					if (
						submit.classList.contains("quantity__down") &&
						quantityInput.value === 0
					) {
						this.prompt(product);
					} else {
						const form = product.querySelector(
							".update-cartpreview-product-form",
						);
						const lineid = product.querySelector(".js-line-id").value;
						const data = new FormData(form);
						const url = form.getAttribute("action");
						buttonLoader.start(quantityLoader);

						fetch(url, {
							method: "POST",
							headers: {
								"Content-Type": "application/json;charset=UTF-8",
							},
							body: InitCart.getData(form),
						})
							.then((response) => {
								if (response.status === 409) {
									alert("Vara er ekki til á lager");
								} else {
									return response.json().then((data) => {
										const orderInfo = data;

										buttonLoader.success(quantityLoader);
										InitCart.updateTotalQuantity(orderInfo.totalQuantity);
										const currentOrderLine = orderInfo.orderLines.filter(
											(line) => {
												return line.key === lineid;
											},
										)[0];
										InitCart.updateOrderLinePrice(
											lineid,
											currentOrderLine.amount.withVat.currencyString,
										);
										InitCart.updateTotalPrice(
											orderInfo.chargedAmount.currencyString,
										);
									});
								}
							})
							.catch((error) => {
								buttonLoader.reset(quantityLoader);
								return error;
							});
					}
				});
			});
		}
	}

	bindRemoveSinglePreview(product) {
		const form = product.querySelector(".remove-from-cart");
		if (form) {
			form.addEventListener("click", (e) => {
				this.prompt(product);
			});
		}
	}

	bindCouponForm() {
		const form = document.getElementsByClassName("cart__coupon-form")[0];

		if (form) {
			form.addEventListener("submit", (e) => {
				e.preventDefault();
				this.submitCoupon(form);
			});
		}
	}

	getData(form) {
		var formData = new FormData(form);
		var jsonObject = {};
		formData.forEach((value, key) => (jsonObject[key] = value));
		return JSON.stringify(jsonObject);
	}

	addOrderLine(evt) {
		evt.preventDefault();

		const addtocartbtn = evt.target.querySelector(".add-to-cart");

		const url = evt.target.getAttribute("action");

		if (addtocartbtn) {
			buttonLoader.start(addtocartbtn);
		}

		fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json;charset=UTF-8",
			},
			body: InitCart.getData(evt.target),
		})
			.then((response) => {
				if (response.status === 409) {
					alert("Vara er ekki til á lager");
				} else {
					return response.json().then((data) => {
						const orderInfo = data;

						const totalQuantity = orderInfo.totalQuantity;

						InitCart.updateTotalQuantity(totalQuantity);
						InitCart.renderCartBtn();
						InitCart.renderPreviewCart(orderInfo);

						buttonLoader.success(addtocartbtn);
					});
				}
			})
			.catch((error) => {
				buttonLoader.reset(addtocartbtn);
				return error;
			});
	}

	submitCoupon(form) {
		const url = form.getAttribute("action");
		var errorContainer = document.querySelector(".alert");

		if (errorContainer) {
			errorContainer.remove();
		}

		fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json;charset=UTF-8",
			},
			body: InitCart.getData(form),
		})
			.then((response) => {
				if (response.status === 200) {
					window.location.reload();
				} else {
					throw Error;
				}
			})
			.catch((error) => {
				form.insertAdjacentHTML(
					"afterend",
					'<div class="alert error">Afsláttar kóði finnst ekki eða er ekki leyfilegur á þessa pöntun.</div>',
				);

				return error;
			});

		axios
			.post(url, data)
			.then((res) => {
				window.location.reload();
			})
			.catch((error) => {
				form.insertAdjacentHTML(
					"afterend",
					'<div class="alert error">Afsláttar kóði finnst ekki eða er ekki leyfilegur á þessa pöntun.</div>',
				);
			});
	}

	prompt(product) {
		const prompt = product.querySelector(".cartpreview__removeprompt");
		const deletebtn = product.querySelector(".cartpreview__delete");
		const quan = product.querySelector(".update-cartpreview-product-form");
		const quantityInput = product.querySelector(".cartpreview__qInput");

		if (prompt) {
			if (quantityInput.value === 0) {
				quantityInput.value = 1;
			}

			const confirm = prompt.querySelector(".confirm-prompt");
			const reject = prompt.querySelector(".exit-prompt");

			if (quan) {
				quan.classList.toggle("hide");
				deletebtn.classList.toggle("hide");
			}

			prompt.classList.toggle("hide");

			confirm.addEventListener("click", (e) => {
				e.preventDefault();
				this.removePreviewItem(product);
			});

			reject.addEventListener("click", (e) => {
				e.preventDefault();
				prompt.classList.add("hide");
				quan.classList.remove("hide");
				deletebtn.classList.remove("hide");
			});
		}
	}

	closeCartPreview() {
		const { cartPreview } = this.props;
		cartPreview.classList.remove("cartpreview--show");
		document.body.classList.remove("disable-scroll");
		document
			.querySelector(".js-hamburger")
			.classList.remove("hamburger-is-active");
	}

	updateTotalQuantity(quantity) {
		const { totalQuantity } = this.props;
		totalQuantity.innerHTML = quantity;
	}

	updateOrderLinePrice(id, price) {
		const currentLine = document.getElementById(id);
		currentLine.querySelector(".cartpreview__price").innerHTML = price;
	}

	updateTotalPrice(price) {
		const totalPrice = document.querySelector(".js-cart-total");
		totalPrice.innerHTML = price;
	}

	removePreviewItem(product) {
		const { cartPreview, totalQuantity } = this.props;
		const form = product.querySelector(".removeFromCartForm");

		if (form) {
			const url = form.getAttribute("action");

			fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json;charset=UTF-8",
				},
				body: InitCart.getData(form),
			})
				.then((response) => {
					return response.json().then((data) => {
						const orderInfo = data;

						if (!("remove" in Element.prototype)) {
							if (product.parentNode) {
								product.parentNode.removeChild(product);
							}
						} else {
							product.remove();
						}
						this.updateTotalQuantity(orderInfo.totalQuantity);
						this.updateTotalPrice(orderInfo.chargedAmount.currencyString);
						if (orderInfo.orderLines.length === 0) {
							document
								.querySelector(".cartbtn-js")
								.classList.add("header__buttonCart--hide");
							this.closeCartPreview();
							disableScroll.off();
						}
					});
				})
				.catch((error) => {
					return error;
				});
		}
	}

	renderCartBtn() {
		const { toggleCart } = this.props;
		if (toggleCart.classList.contains("header__buttonCart--hide")) {
			toggleCart.classList.remove("header__buttonCart--hide");
		}
	}

	renderOrderLines(resolve) {
		const { cartPreview } = this.props;
		const cartContent = cartPreview.querySelector(".cartpreview__content");

		var form = document.getElementById("getOrderForm");

		const url = form.getAttribute("action");

		fetch(url, {
			method: "POST",
			body: new FormData(form),
		})
			.then((response) => {
				return response.json().then((data) => {
					const source = document.getElementById("cart-template").innerHTML;
					getTemplate(source, cartContent, data.item);
					resolve();
				});
			})
			.catch((error) => {
				return error;
			});
	}
	cartPreveiewcloseEvent() {
		disableScroll.off();
		InitCart.closeCartPreview();
	}
	renderPreviewCart() {
		const { cartPreview } = this.props;

		const promise = new Promise((resolve) => {
			this.renderOrderLines(resolve);
		});

		promise
			.then(() => {
				const products = document.querySelectorAll(".js-cart-item");

				if (products) {
					Array.prototype.forEach.call(products, (product) => {
						this.bindRemoveSinglePreview(product);
						this.bindUpdateQuantity(product);
					});
				}
			})
			.then(() => {
				const cartpreviewCloseBtn =
					document.querySelector(".cartpreview-close");
				if (cartpreviewCloseBtn) {
					cartpreviewCloseBtn.addEventListener(
						"click",
						InitCart.cartPreveiewcloseEvent,
					);
				}
				const cartPreview = document.querySelector(".cartpreview");
				const wrapper = document.querySelector(".wrapper");
				const footer = document.querySelector("footer");
				document.body.classList.add("disable-scroll");
				cartPreview.classList.add("cartpreview--show");
				const menuButton = document.querySelector(".js-menu");
				const hamburger = document.querySelector(".js-hamburger");
				hamburger.classList.add("hamburger-is-active");
				this.updateButtonText(menuButton);
				disableScroll.on(wrapper);
				disableScroll.on(footer);
			});
	}

	updateButtonText(button) {
		const textEl = button.querySelector(".button__text");
		const text = textEl.getAttribute("data-text");
		const currentText = textEl.innerText;

		textEl.setAttribute("data-text", currentText);
		textEl.innerText = text;
	}
}

const InitCart = new Cart();

export default InitCart;

/*
const xhr = new XMLHttpRequest()
xhr.open(addToCartForm.getAttribute("method"), addToCartForm.getAttribute("action"))

xhr.onload = () => {
  const resp = JSON.parse(xhr.response)

  if (xhr.status >= 200 && xhr.status < 300) {
    if (resp.success) {
      //
    } else {
      //
    }
  } else {
    
  }
}
xhr.send(data);
*/
